import { render, staticRenderFns } from "./TimelineSection.vue?vue&type=template&id=63140484&scoped=true&"
import script from "./TimelineSection.vue?vue&type=script&lang=js&"
export * from "./TimelineSection.vue?vue&type=script&lang=js&"
import style0 from "./TimelineSection.vue?vue&type=style&index=0&id=63140484&scoped=true&lang=css&"
import style1 from "./TimelineSection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63140484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
